export var EVideoAspectRatio;
(function (EVideoAspectRatio) {
    EVideoAspectRatio["AspectRatio16x9"] = "AspectRatio16x9";
    EVideoAspectRatio["AspectRatio4x3"] = "AspectRatio4x3";
})(EVideoAspectRatio || (EVideoAspectRatio = {}));
